import { forwardRef } from "react";

import { ParagraphStyled } from "./Paragraph.styles";
import { TParagraphProps, TParagraphRef } from "./Paragraph.types";

const Paragraph = forwardRef<TParagraphRef, TParagraphProps>(function Paragraph({
  weight = "base",
  variant = "base",
  textAlign,
  ...rest
},
ref) {
  return (
    <ParagraphStyled
      ref={ref}
      $weight={weight}
      $variant={variant}
      $textAlign={textAlign}
      {...rest}
    />
  );
});

export default Paragraph;
